var pt = pt || {};
pt.blocografico = pt.blocografico || {};
pt.blocografico.modules = pt.blocografico.modules || {};
pt.blocografico.modules.footer = pt.blocografico.modules.footer || {};
pt.blocografico.modules.footer = (function () {
  const sitemapOptions = {
    menuSelector: "footer .links .menu",
    menuOptionOpenClass: "open",
    arrowSelector: ".arrow",
    arrowOpenedClass: "icon-v",
    arrowClosedClass: "icon-V",
    hiddenElementClass: "hidden-xs",
  };

  const portoEditoraMenuOptions = {
    overlayElementSelector: "footer .layer-1 .overlay",
    arrowSelector: ".arrow span",
    arrowOpenedClass: "icon-v",
    arrowClosedClass: "icon-V",
  };

  function init() {
    document.addEventListener("DOMContentLoaded", function () {
 
      initSiteMap();
    });
  }
 

  function initSiteMap() {
    const menuItems = document.querySelectorAll(`${sitemapOptions.menuSelector} [data-id]`);

    menuItems.forEach(function (menuItem) {
      menuItem.addEventListener("click", function () {
        menuOptionClick(this, true);
      });
    });
  }
 

  init();

  // You can return an empty object or any other value if needed.
  return {};
})();
